// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-1Vv46sQM"};